import React from 'react';
import PropTypes from 'prop-types';
import cname from '../WidgetStyles';

/**
 * AnimationSlider:
 *  - Component display a LottieAnimation with a slider.
 *  - The Slider can be dragged to view changes in the animtion realtime
 */
export function AnimationSlider(props) {
  return (
    <div
      role='region'
      aria-label={props.ariaLabel}
      className={`${cname.animSlider} ${props.allowOverflow ? cname.allowOverflow : ""}`}>
        {props.children}
    </div>
  );
}

AnimationSlider.propTypes = {
  /**
   * AriaLabel for slider Animation
   */
  ariaLabel: PropTypes.string,
  /**
   * Animation Componets for widget
   */
  children: PropTypes.array,
};

AnimationSlider.defaultProps = {
  className: '',
  ariaLabel: '',
};
